import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Query, compose } from "react-apollo";
import { Message } from "semantic-ui-react";
import { Trans } from "react-i18next";

import Details from "./Details";
import trainingUnitQuery from "../../../gql/trainingUnitQuery";
import { ROLE_SYSTEM_ADMINISTRATOR } from "../../../security/role";
import Spinner from "../../spinner/Spinner";

function DetailsContainer({ id, handleClose, myRole, onRefreshData }) {
  const isAdminView = myRole === ROLE_SYSTEM_ADMINISTRATOR;
  const [isModalOpen, setModalOpen] = useState(true);
  const [selectedView, setSelectedView] = useState(
    isAdminView ? "registrations" : "info"
  );

  const onModalClose = () => {
    setModalOpen(false);

    handleClose();
  };

  const selectView = view => () => {
    setSelectedView(view);
  };

  return (
    <Query query={trainingUnitQuery} variables={{ id }}>
      {({ loading, error, data, refetch }) => {
        if (loading) return <Spinner />;
        if (error) {
          return <Message error content={<Trans i18nKey="errors.noData" />} />;
        }

        const { trainingUnit } = data;

        return (
          <Details
            trainingUnit={trainingUnit}
            showModal={isModalOpen}
            selectView={selectView}
            selectedView={selectedView}
            handleClose={onModalClose}
            isAdminView={isAdminView}
            onUpdateTrainingUnit={refetch}
            onRefreshData={onRefreshData}
          />
        );
      }}
    </Query>
  );
}

DetailsContainer.displayName = "coursePlan/details/DetailsContainer";

const mapStateToProps = ({ auth: { role } }) => ({
  myRole: role
});

export default compose(
  connect(mapStateToProps),
  withRouter
)(React.memo(DetailsContainer));
